var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerCls},[(_vm.path && _vm.ready)?_c('iframe',{style:(_vm.frameStyle),attrs:{"src":_vm.iframeSrc,"frameborder":"0","allow":"autoplay; fullscreen; picture-in-picture","title":"פתיח מתחילים - מירן"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }